import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { LOCK_STATUS } from '../../store/api/status'

export default class LockStatusIcon extends React.Component {
    getIcon(status) {
        var icon = 'exclamation-triangle'
        switch (status) {
            case 'locked':
                icon = 'lock'
                break
            case 'unlocked':
                icon = 'unlock'
                break
            default:
                break
        }
        return icon
    }

    getTooltip(status) {
        var tooltip = ''

        switch (status) {
            case LOCK_STATUS.LOCKED:
                tooltip = 'This idea locked. No edits or comments are possible.'
                break
            case LOCK_STATUS.UNLOCKED:
                tooltip = 'This idea is unlocked. Users can edit and comment.'
                break
            default:
                break
        }
        return tooltip
    }

    onClick = (e) => {
        this.props.onClick && this.props.onClick(e.target.id)
    }

    render() {
        var icon = this.getIcon(this.props.status)

        return (
            <div className="status-balls dropdown">
                <button
                    className="status-button"
                    disabled={this.props.disabled}
                    data-toggle="dropdown"
                    data-toggle-second="tooltip"
                    data-placement="top"
                    title={this.getTooltip(this.props.status)}>
                    <h5 className="text-secondary">
                        <FontAwesomeIcon icon={icon} />
                    </h5>
                </button>

                <div className="dropdown-menu" style={{ width: '220px' }}>
                    <button
                        onClick={this.onClick}
                        id={LOCK_STATUS.LOCKED}
                        className="dropdown-item"
                        disabled={this.props.status === LOCK_STATUS.LOCKED}>
                        Lock
                    </button>
                    <button
                        onClick={this.onClick}
                        id={LOCK_STATUS.UNLOCKED}
                        className="dropdown-item"
                        disabled={this.props.status === LOCK_STATUS.UNLOCKED}>
                        Unlock
                    </button>
                </div>
            </div>
        )
    }
}
